// V17.523 (Phase 1): registry icon names → lucide components (section icons; items have none — Rule 6).
import {
  Banknote, BarChart3, Briefcase, Building2, CheckSquare, Coins, Cpu, GraduationCap, Home, LayoutGrid, MapPin,
  MessageSquare, Share2, Shield, SlidersHorizontal, Truck, Users, type LucideIcon,
} from 'lucide-react';
import type { NavIconName } from '../../app/navigation';

export const NAV_ICONS: Record<NavIconName, LucideIcon> = {
  LayoutGrid, Users, Briefcase, MapPin, Share2, Home, Building2, Coins, Cpu, Banknote, Truck, MessageSquare, CheckSquare,
  BarChart3, GraduationCap, Shield, SlidersHorizontal,
};
